import { render, staticRenderFns } from "./AlarmCenterDyw.vue?vue&type=template&id=2c94af50&scoped=true"
import script from "./AlarmCenterDyw.vue?vue&type=script&lang=js"
export * from "./AlarmCenterDyw.vue?vue&type=script&lang=js"
import style0 from "./AlarmCenterDyw.vue?vue&type=style&index=0&id=2c94af50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94af50",
  null
  
)

export default component.exports